import { render, staticRenderFns } from "./TreatmentForm.vue?vue&type=template&id=611d5a42"
import script from "./TreatmentForm.vue?vue&type=script&lang=js"
export * from "./TreatmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports